import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col gap-y-5" }

import { computed, watch, ref } from "vue"
import { CalendarIcon, ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { formatters, predicates } from "@/shared/utils/dateUtils"
import GgmsCalendar from "@/components/GgmsCalendar.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarDateScheduleComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const isSelectedDateToday = ref(false)
const minHour = computed(() => (isSelectedDateToday.value ? "now" : "today"))

watch(
    () => [workflowStore.modelValue?.date, workflowStore.modelValue?.time],
    () => {
        isSelectedDateToday.value = predicates.isToday(new Date(workflowStore.modelValue?.date))
        if (
            workflowStore.modelValue?.date &&
            workflowStore.modelValue?.time &&
            predicates.isEarlierToday(workflowStore.modelValue?.date, workflowStore.modelValue?.time)
        ) {
            const newDate = new Date()
            let hours = newDate.getHours()
            const minutes = String(newDate.getMinutes()).padStart(2, "0")
            const period = hours >= 12 ? "PM" : "AM"
            hours = hours % 12 || 12 // Convert to 12-hour format, 0 becomes 12
            const hoursStr = String(hours).padStart(2, "0")
            workflowStore.modelValue.time = `${hoursStr}:${minutes} ${period}`
        }
        //convert time and date into ISO date
        if (workflowStore.modelValue?.date && workflowStore.modelValue?.time) {
            workflowStore.modelValue.dateTime = formatters.dateTimeConverter(
                workflowStore.modelValue.time,
                workflowStore.modelValue.date
            )
        }
        if (workflowStore.modelValue?.date) {
            workflowStore.areButtonDisabled = false
        }
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-lg contacting-7 font-medium text-black pb-6" }, "Date when workflow should trigger", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GgmsCalendar, {
        modelValue: _unref(workflowStore).modelValue.date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.date) = $event)),
        position: "below",
        label: "Select day",
        minDate: "today",
        showTime: false,
        showDate: true,
        iconStart: _unref(CalendarIcon)
      }, null, 8, ["modelValue", "iconStart"]),
      _createVNode(GgmsCalendar, {
        modelValue: _unref(workflowStore).modelValue.time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
        position: "below",
        label: "Select time",
        minDate: minHour.value,
        showTime: true,
        showDate: false,
        iconStart: _unref(ClockIcon)
      }, null, 8, ["modelValue", "minDate", "iconStart"])
    ])
  ]))
}
}

})